module.exports = __webpack_public_path__ + "img/destination-6.692a7fc4.svg";